"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLink = exports.CreateRoomLink = exports.CreateCommissionLink = exports.CreateDemandLink = exports.LoginLink = exports.FondeeLogoLink = exports.HeaderBackLink = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const linkCss = {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    height: '100%',
    cursor: 'pointer',
};
const HeaderBackLink = ({ altBackFn, isCloseSvg, }) => {
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: linkCss, onClick: () => {
            altBackFn ? altBackFn() : (0, functions_1.goBackOrMain)();
        } }, { children: isCloseSvg ? (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) : (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })));
};
exports.HeaderBackLink = HeaderBackLink;
const FondeeLogoLink = () => ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: linkCss, onClick: functions_1.goToMain }, { children: (0, jsx_runtime_1.jsx)(svgs_1.FondeeLogoSvg, {}) })));
exports.FondeeLogoLink = FondeeLogoLink;
const LoginLink = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const redirectToLoginPage = () => {
        if (!window.location.pathname.includes('login')) {
            window.location.href = (0, string_utils_1.loginReturnPath)();
        }
    };
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: linkCss, onClick: redirectToLoginPage }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('로그인') })) })));
};
exports.LoginLink = LoginLink;
const createLinkCss = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '88px',
    height: '32px',
    padding: '0 12px',
    '@media (max-width: 840px)': { minWidth: '77px', padding: '0 6px' },
    borderRadius: '6px',
    cursor: 'pointer',
};
const CreateDemandLink = ({ isLoggedIn }) => {
    const demandCreatePath = '/room/demand-create';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80 surface-white", css: Object.assign(Object.assign({}, createLinkCss), { border: '1px solid var(--gray-10)' }), onClick: () => {
            if (isLoggedIn)
                window.location.href = demandCreatePath;
            else
                window.location.href = (0, string_utils_1.loginReturnPath)(demandCreatePath);
        } }, { children: t('수요조사') })));
};
exports.CreateDemandLink = CreateDemandLink;
const CreateCommissionLink = ({ isLoggedIn }) => {
    const commissionCreatePath = '/room/commission-create';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4", css: Object.assign(Object.assign({}, createLinkCss), { backgroundColor: 'var(--primary-main)', color: 'var(--white)' }), onClick: () => {
            if (isLoggedIn)
                window.location.href = commissionCreatePath;
            else
                window.location.href = (0, string_utils_1.loginReturnPath)(commissionCreatePath);
        } }, { children: t('커미션') })));
};
exports.CreateCommissionLink = CreateCommissionLink;
const CreateRoomLink = ({ isLoggedIn }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4", css: Object.assign(Object.assign({}, createLinkCss), { backgroundColor: 'var(--primary-main)', color: 'var(--white)' }), onClick: () => {
            if (isLoggedIn)
                (0, functions_1.goToCreateRoom)();
            else
                window.location.href = (0, string_utils_1.loginReturnPath)('/room/room_create_new/');
        } }, { children: t('판매시작') })));
};
exports.CreateRoomLink = CreateRoomLink;
const MessageLink = () => ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: "/messages", css: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px',
        '@media (max-width: 768px)': {
            padding: 0,
        },
        borderRadius: '8px',
    } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MessageIconSvg, {}) })));
exports.MessageLink = MessageLink;
